import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Segmented, { SegmentedOption } from 'components/DesignSystem/Segmented';
import { DisplayMode } from 'helper/products/synopticCharts';
import { selectDisplayMode, setDisplayMode } from 'redux/reducers/synopticChartsReducer';

const MODES: SegmentedOption<DisplayMode>[] = [
  { value: DisplayMode.Images, label: 'Imagem' },
  { value: DisplayMode.Gif, label: 'GIF' },
];

export default function DisplayModeToggle() {
  const dispatch = useDispatch();
  const displayMode: DisplayMode = useSelector(selectDisplayMode);

  return (
    <Segmented
      className="sc-mobile-mode-toggle"
      ariaLabel="Modo de exibição"
      options={MODES}
      value={displayMode}
      onChange={(mode) => dispatch(setDisplayMode(mode))}
    />
  );
}
